module.exports = __webpack_public_path__ + "static/media/p2.147ecf3e.png";